import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://ysytcvouysgeuaxlhfhk.supabase.co";
const supabaseAnonKey = "sb_publishable__beFxtVT_ijNq8UQ21F_Sg_d-YNxApZ";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);